import { useCallback, useMemo, useRef } from 'react';

/**
 * Regelt, ob ein Dropdown den Fokus beim Schliessen an seinen Trigger
 * zurueckgibt.
 *
 * Hintergrund: Radix gibt den Fokus immer zurueck. Schliesst man das Menue
 * dann per Tastatur (Escape oder Enter), zeigt der Browser am Trigger den
 * Fokus-Ring – bei Maus-Bedienung bleibt so ein Kreis um das Icon stehen,
 * den niemand angefordert hat.
 *
 * Deshalb: Fokus nur zurueckgeben, wenn das Menue per Tastatur geoeffnet
 * wurde. Genau dort ist der Ring die richtige Orientierungshilfe.
 */
export default function useMenuFocusReturn() {
  const openedByPointer = useRef(false);

  const triggerProps = useMemo(
    () => ({
      onPointerDown: () => {
        openedByPointer.current = true;
      },
      onKeyDown: () => {
        openedByPointer.current = false;
      },
    }),
    [],
  );

  const onCloseAutoFocus = useCallback((event: Event) => {
    if (openedByPointer.current) {
      event.preventDefault();
    }
  }, []);

  return { triggerProps, onCloseAutoFocus };
}
